import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let gallerySwiperWr = document.querySelectorAll('.gallery-swiper-wr');
gallerySwiperWr.forEach((el) => {
  if (el) {
    let parentEl = el.parentElement;
    const breakpoint = 768;

    let swiperEl = el.querySelector('.swiper');
    let nextEl = parentEl.querySelectorAll('.swiper-button-next');
    let prevEl = parentEl.querySelectorAll('.swiper-button-prev');
    let paginationEl = parentEl.querySelectorAll('.swiper-pagination');

    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    const isRtl = window.innerWidth >= breakpoint;

    if (isRtl) {
      swiperEl.setAttribute('dir', 'rtl');
      const slides = Array.from(wrapper.children);
      slides.reverse().forEach((slide) => wrapper.appendChild(slide));
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true,
      observeParents: true,
      spaceBetween: 6,
      slidesPerView: 'auto',
      threshold: 10,
      loop: true,
      dir: isRtl ? 'rtl' : 'ltr',
      pagination: {
        el: paginationEl.length ? Array.from(paginationEl) : null,
        clickable: true,
      },
      navigation: {
        nextEl: nextEl.length ? Array.from(nextEl) : null,
        prevEl: prevEl.length ? Array.from(prevEl) : null,
      },
      breakpoints: {
        640: {
          spaceBetween: 14,
        },
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    });
    swiperObserver(swiper);

    window.addEventListener('resize', () => {
      const shouldBeRtl = window.innerWidth >= breakpoint;
      if (shouldBeRtl && swiperEl.getAttribute('dir') !== 'rtl') {
        swiperEl.setAttribute('dir', 'rtl');
        swiper.changeLanguageDirection('rtl');
      } else if (!shouldBeRtl && swiperEl.getAttribute('dir') !== 'ltr') {
        swiperEl.setAttribute('dir', 'ltr');
        swiper.changeLanguageDirection('ltr');
      }
    });
  }
});